import { Box, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { ChevronRightIcon } from "lucide-react";
import type React from "react";

interface DashboardRowProps {
	title: string;
	description: string;
	imageSrc: string;
	onClick: () => void;
	disabled?: boolean;
}

export const DashboardPicturedRow: React.FC<DashboardRowProps> = ({
	title,
	description,
	imageSrc,
	onClick,
	disabled = false,
}) => {
	const theme = useTheme();

	return (
		<Stack
			onClick={disabled ? undefined : onClick}
			position="relative"
			width="100%"
			height={180}
			borderRadius={theme.radii.lg}
			overflow="hidden"
			sx={{ opacity: disabled ? 0.4 : 1 }}
		>
			<Box
				component="img"
				src={imageSrc}
				width="100%"
				height="100%"
				sx={{ objectFit: "cover" }}
			/>
			<Typography
				variant="h6"
				position="absolute"
				top={theme.spacing(2)}
				left={theme.spacing(2)}
				color={theme.palette.darkmodeText.white}
				fontWeight="bold"
				width="55%"
				whiteSpace="normal"
				lineHeight={1.2}
				sx={{ wordBreak: "break-word" }}
			>
				{title}
			</Typography>
			<Typography
				variant="deprecatedBody1"
				position="absolute"
				bottom={theme.spacing(2)}
				left={theme.spacing(2)}
				color={theme.palette.darkmodeText.white}
				width="50%"
				whiteSpace="normal"
				lineHeight={1.2}
				sx={{ wordBreak: "break-word" }}
			>
				{description}
			</Typography>
			<IconButton
				sx={{
					position: "absolute",
					right: theme.spacing(2),
					top: "50%",
					transform: "translateY(-50%)",
					color: theme.palette.darkmodeText.white,
				}}
			>
				<ChevronRightIcon />
			</IconButton>
		</Stack>
	);
};
